module.exports = __webpack_public_path__ + "media/sub3-7-2.ebff974d.mp4";